import React, { useState } from 'react';
import { Input, Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const FeedbackPage = () => {
    const [comment, setComment] = useState('');
    const [fileList, setFileList] = useState([]);
  
    const handleCommentChange = (e) => {
      setComment(e.target.value);
    };
  
    const handleFileChange = ({ fileList }) => {
      setFileList(fileList);
    };
  
    const handleSubmit = () => {
      // Handle submit logic
      console.log('Submitted comment:', comment);
      console.log('Uploaded files:', fileList);
      // Clear form data
      setComment('');
      setFileList([]);
    };
  
    return (
      <div>
        <h1>Feedback</h1>
        <Input.TextArea
          placeholder="Enter your feedback"
          value={comment}
          onChange={handleCommentChange}
          rows={4}
        />
        <br />
        <br />
        <Upload
          fileList={fileList}
          onChange={handleFileChange}
          beforeUpload={() => false} // Prevent automatic upload
        >
          <Button icon={<UploadOutlined />}>Upload Screenshot</Button>
        </Upload>
        <br />
        <br />
        <Button type="primary" onClick={handleSubmit}>Submit</Button>
      </div>
    );
  };
  
  export default FeedbackPage;
  
  